import SFWebhooksComponent from './sf-webhooks.component';

const DEPENDENCIES = [];

let moduleName = 'ais.sf-webhooks';

try {
  angular.module( moduleName );
  console.error( `Angular module '${ moduleName }' has already been created elsewhere. Aborting this creation attempt.` );
}
catch( err ) {
  angular
    .module(moduleName, DEPENDENCIES)
    .component('sfWebhooks', SFWebhooksComponent)
}
